import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rate-fixation-grid',
  templateUrl: './rate-fixation-grid.component.html',
  styleUrls: ['./rate-fixation-grid.component.css']
})
export class RateFixationGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/recovery/rate-fixation/rate-fixation-grid/rate-fixation-grid.component.ts